import { UserSearchDialogState } from ".";

export const UserSearchDialogInitialState: UserSearchDialogState = {
  userList: [],
  isShow: false,
  isApply: false,
  notFound: false,
};
